import type { RowData } from '@tanstack/react-table';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

// v9's RowData constraint rules out a single StrictColumnDef<unknown> shared
// across tables, so the row-agnostic column is minted per row type instead.
export function lineNumberColumn<T extends RowData>(): StrictColumnDef<T> {
  return defineColumn<T>({
    id: '#',
    minWidth: 50,
    accessorFn: () => '',
    cell: ({ row, table }) => {
      const visualIndex = table.getSortedRowModel().flatRows.findIndex((r) => r.id === row.id);

      return <>{visualIndex + 1}</>;
    },
  });
}
